export default __webpack_public_path__ + "assets/f4a2430f04cead87f8b9573196cf8c96.png";